// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import MonthlyRent from '../monthly-rent';

const MonthlyRentInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  className,
  fullWidth,
}) => {
  return (
    <MonthlyRent label={label} className={className} fullWidth={fullWidth} />
  );
};

export default MonthlyRentInputWithAnalytics;
